"use strict";
var APP = (function () {

    // Properties
    var _result = Object.create( null );
    var  _config, _display, _game, _managers, _popups, _save, _scenes, _ui;

    Object.defineProperties( _result, {
        "config": {
            get: function () { return _config; },
            set: function ( p_val ) { if ( !_config ) _config = p_val; },
            enumerable: true
        },
        "display": {
            get: function () { return _display; },
            set: function ( p_val ) { if ( !_display ) _display = p_val; },
            enumerable: true
        },
        "game": {
            get: function () { return _game; },
            set: function ( p_val ) { if ( !_game ) _game = p_val; },
            enumerable: true
        },
        "managers": {
            get: function () { return _managers; },
            set: function ( p_val ) { if ( !_managers ) _managers = p_val; },
            enumerable: true
        },
        "popups": {
            get: function () { return _popups; },
            set: function ( p_val ) { if ( !_popups ) _popups = p_val; },
            enumerable: true
        },
        "save": {
            get: function () { return _save; },
            set: function ( p_val ) { _save = p_val; },
            enumerable: true
        },
        "scenes": {
            get: function () { return _scenes; },
            set: function ( p_val ) { if ( !_scenes ) _scenes = p_val; },
            enumerable: true
        },
        "ui": {
            get: function () { return _ui; },
            set: function ( p_val ) { if ( !_ui ) _ui = p_val; },
            enumerable: true
        },
    });

    return _result;

})();

APP.config = (function (){

    // Properties
    var _result = Object.create( null );

    Object.defineProperties( _result, {
        "debugEnabled": {
            enumerable: true,
            writable: true,
            value: false
        },
        "id": {
            enumerable: true,
            writable: false,
            value: gameId//"13062761"
        },
        "language": {
            enumerable: true,
            writable: false,
            value: "en"
        },
        "maxListeners": {
            enumerable: true,
            writable: false,
            value: 100
        },
        "stageWidth": {
            enumerable: true,
            writable: false,
            value: 1024
        },
        "stageHeight": {
            enumerable: true,
            writable: false,
            value: 600
        },
        "version": {
            enumerable: true,
            writable: true
        }
    });
    
    return _result;
})();

APP.display = (function (){

    // Properties
    var _result = Object.create( null );
    var _canvas, _stage, _renderer;

    Object.defineProperties( _result, {
        "canvas": {
            get: function () { return _canvas; },
            set: function ( p_val ) { if ( _canvas != p_val ) _canvas = p_val; },
            enumerable: true
        },
        "renderer": {
            get: function () { return _renderer; },
            set: function ( p_val ) { if ( _renderer != p_val ) _renderer = p_val; },
            enumerable: true
        },
        "stage": {
            get: function () { return _stage; },
            set: function ( p_val ) { if ( _stage != p_val ) _stage = p_val; },
            enumerable: true
        },
    });
    
    return _result;

})();

APP.game = (function (){

    // Properties
    var _result = Object.create( null );
    var _animal, _cage, _level, _btnPause;

    Object.defineProperties( _result, {
        "debugEnabled": {
            enumerable: true,
            writable: false,
            value: false
        },
        "btnPause": {
            get: function () { return _btnPause; },
            set: function ( p_val ) { if ( _btnPause !== p_val ) _btnPause = p_val; },
            enumerable: true
        },
        "AnimalConfig": {
            enumerable: true,
            writable: false,
            value: {
                MIN_DELTA_AI: 3,
                MAX_DELTA_AI: 10,
                MIN_MOVE_SPEED: 2,
                MAX_MOVE_SPEED: 5
            }
        },
        "AnimalObject": {
            get: function () { return _animal; },
            set: function ( p_val ) { if ( !_animal ) _animal = p_val; },
            enumerable: true
        },
        "AnimalEvent": {
            enumerable: true,
            writable: false,
            value: {
                DRAG_START: "animalEvt_dragStart",
                DRAG_END: "animalEvt_dragEnd",
                MOVING: "animalEvt_moving",
                UPDATED_STATE: "animalEvt_updatedState"
            }
        },
        "AnimalState": {
            enumerable: true,
            writable: false,
            value: {
                IDLE: 1,
                MOVE: 2
            }
        },
        "AnimalType": {
            enumerable: true,
            writable: false,
            value: {
                GOAT: 1,
                SHEEP: 2,
                LION: 3
            }
        },
        "CageObject": {
            get: function () { return _cage; },
            set: function ( p_val ) { if ( !_cage ) _cage = p_val; },
            enumerable: true
        },
        "LevelConfig": {
            enumerable: true,
            writable: false,
            value: {
                GAME_TIME: 90,
                RATINGS: [ 500, 1000, 1500 ]
            }
        },
        "LevelObject": {
            get: function () { return _level; },
            set: function ( p_val ) { if ( !_level ) _level = p_val; },
            enumerable: true
        },
        "LevelEvent": {
            enumerable: true,
            writable: false,
            value: {
                START: "levelEvt_start",
                END: "levelEvt_end",
                UPDATED_SCORE: "levelEvt_updatedScore"
            }
        },
    });

    // Return result
    return _result;

})();

APP.managers = (function (){

    // Properties
    var _result = Object.create( null );
    var _event, _json, _load, _scale, _scene, _sound, _storage, _update;

    Object.defineProperties( _result, {
        "event": {
            get: function () { return _event; },
            set: function ( p_val ) { if ( !_event ) _event = p_val; },
            enumerable: true
        },
        "json": {
            get: function () { return _json; },
            set: function ( p_val ) { if ( !_json ) _json = p_val; },
            enumerable: true
        },
        "load": {
            get: function () { return _load; },
            set: function ( p_val ) { if ( !_load ) _load = p_val; },
            enumerable: true
        },
        "scale": {
            get: function () { return _scale; },
            set: function ( p_val ) { if ( !_scale ) _scale = p_val; },
            enumerable: true
        },
        "scene": {
            get: function () { return _scene; },
            set: function ( p_val ) { if ( !_scene ) _scene = p_val; },
            enumerable: true
        },
        "sound": {
            get: function () { return _sound; },
            set: function ( p_val ) { if ( !_sound ) _sound = p_val; },
            enumerable: true
        },
        "storage": {
            get: function () { return _storage; },
            set: function ( p_val ) { if ( !_storage ) _storage = p_val; },
            enumerable: true
        },
        "update": {
            get: function () { return _update; },
            set: function ( p_val ) { if ( !_update ) _update = p_val; },
            enumerable: true
        },
    });

    return _result;
})();

APP.popups = (function (){

    // Properties
    var _result = Object.create( null );
    var _confirmation, _pause, _end;

    Object.defineProperties( _result, {
        "ConfirmationPopup": {
            get: function () { return _confirmation; },
            set: function ( p_val ) { if ( !_confirmation ) _confirmation = p_val; },
            enumerable: true
        },
        "PausePopup": {
            get: function () { return _pause; },
            set: function ( p_val ) { if ( !_pause ) _pause = p_val; },
            enumerable: true
        },
        "EndPopup": {
            get: function () { return _end; },
            set: function ( p_val ) { if ( !_end ) _end = p_val; },
            enumerable: true
        },
    });

    // Return
    return _result;

})();

APP.scenes = (function (){

    // Properties
    var _result = Object.create( null );
    var _preloader, _title, _game;

    Object.defineProperties( _result, {
        "PreloaderScene": {
            get: function () { return _preloader; },
            set: function ( p_val ) { if ( !_preloader ) _preloader = p_val; },
            enumerable: true
        },
        "TitleScene": {
            get: function () { return _title; },
            set: function ( p_val ) { if ( !_title ) _title = p_val; },
            enumerable: true
        },
        "GameScene": {
            get: function () { return _game; },
            set: function ( p_val ) { if ( !_game ) _game = p_val; },
            enumerable: true
        }
    });

    // Return
    return _result;

})();

APP.ui = (function (){

    // Properties
    var _result = Object.create( null );
    var _score, _timer;

     Object.defineProperties( _result, {
        "ScoreUI": {
            get: function () { return _score; },
            set: function ( p_val ) { if ( !_score ) _score = p_val; },
            enumerable: true
        },
        "ScoreType": {
            enumerable: true,
            writable: false,
            value: {
                HIGHSCORE: 1,
                SCORE: 2
            }
        },
        "TimerUI": {
            get: function () { return _timer; },
            set: function ( p_val ) { if ( !_timer ) _timer = p_val; },
            enumerable: true
        },
        "TimerType": {
            enumerable: true,
            writable: false,
            value: {
                COUNTDOWN: 1,
                COUNTUP: 2
            }
        },
    });

    // Return
    return _result;

})();